import { css, html, TemplateResult } from 'lit'
import { property } from 'lit/decorators/property.js'
import { ifDefined } from 'lit/directives/if-defined.js'
import '@pushengineering/push-web-components/text'
import '@pushengineering/push-web-components/button'
import '@pushengineering/push-web-components/vertical-stack'
import '@pushengineering/push-web-components/link'

import CirkayElement from '../../internal/CirkayElement'
import { global } from '../../theme/global'

export class ErrorScreen extends CirkayElement {
    /** Error Text  */
    @property({ type: String })
    errorText: string = 'Something went wrong.'

    /** Url for custom faq site  */
    @property({ type: String })
    faqUrl?: string

    constructor() {
        super()
    }

    connectedCallback() {
        super.connectedCallback()
    }

    public render(): TemplateResult {
        return html`
            <pu-vertical-stack
                spacing="32"
                spacingNarrow="24"
                align="center"
                alignNarrow="center"
                justify="center"
                justifyNarrow="center"
                part="error-screen-container"
            >
                <pu-text as="p" variant="bodyLg" withoutMargin part="error-screen-message">
                    ${this.errorText}
                </pu-text>
                <slot name="button"></slot>
                ${this.faqUrl
                    ? html`<pu-text as="p" variant="bodySm" withoutMargin part="error-screen-faq-link">
                          For more help, visit our
                          <pu-link
                              url=${ifDefined(this.faqUrl)}
                              underline
                              target="_blank"
                          >
                              FAQ.
                          </pu-link>
                      </pu-text>`
                    : html``}
            </pu-vertical-stack>
        `
    }

    static styles = [global, css`
        :host {
            font-size: var(--fp-font-size-base, 1em);
        }
    `]
}
